module.exports = __webpack_public_path__ + "static/media/Logo_SmartAsn.6e0c26d4.svg";